jQuery(document).ready(function ($) {
    function toggleExpanded(element) {
        $(element).toggleClass('bgf_expanded')
    }

    function closeDropdowns() {
        $('.bgf_expanded').removeClass('bgf_expanded')
    }

    $('.bgf_filter').on('click', function (event) {
        event.stopPropagation()
        toggleExpanded('.facetwp-facet-products_filter')
        toggleExpanded('.facetwp-facet-bluebird_course')
        toggleExpanded('.facetwp-facet-blog_categories')
    })

    $(document.body).on('click', function () {
        closeDropdowns()
    })

    $(document.body).on(
        'click',
        '.facetwp-facet-products_filter .facetwp-checkbox',
        function (event) {
            $('.facetwp-facet-products_filter').removeClass('bgf_expanded')
        }
    )

    $(document.body).on(
        'click',
        '.facetwp-facet-bluebird_course .facetwp-checkbox',
        function (event) {
            $('.facetwp-facet-bluebird_course').removeClass('bgf_expanded')
        }
    )

    $(document.body).on(
        'click',
        '.facetwp-facet-blog_categories .facetwp-checkbox',
        function (event) {
            $('.facetwp-facet-blog_categories').removeClass('bgf_expanded')
        }
    )

    // Prevent dropdowns from closing when clicking inside them
    $(document).on('click', '.facetwp-type-checkboxes', function (event) {
        event.stopPropagation()
    })
})
